import * as React from 'react';

import DegreeHeader from 'bundles/degree-home/components/DegreeHeader';
import DegreeHeaderCms from 'bundles/degree-home/components/DegreeHeaderCms';
import type { DegreesV1, LinearGradient2 } from 'bundles/degree-home/components/__generated__/DegreesV1';
import type { Partner } from 'bundles/degree-home/types/Degree';
import type { PageContent } from 'bundles/degree-home/types/contentfulTypes';
import type { UserAgent } from 'bundles/item-lti/constants/types';

import _t from 'i18n!nls/degree-home';

type Props = {
  userAgent: UserAgent;
  partners: Array<Partner>;
  degreeMetadata: DegreesV1;
  pageContent?: PageContent | null;
};

export const DegreeHomeHeader = ({ degreeMetadata, pageContent, userAgent, partners }: Props) => {
  const { headerBackgroundColor, headerImage, name } = degreeMetadata;

  if (
    pageContent?.name &&
    pageContent?.partnerInformation?.primaryColor &&
    pageContent?.partnerInformation?.secondaryColor &&
    pageContent?.partnerInformation?.partnerName &&
    pageContent?.partnerInformation?.partnerLogo?.url &&
    pageContent?.partnerInformation?.bannerImage?.url
  ) {
    // Use Contentful data if _all_ of the necessary Contentful fields are defined
    return (
      <DegreeHeaderCms
        degreeName={pageContent.name}
        partnerInfo={{
          rectangularLogo: pageContent.partnerInformation.partnerLogo.url,
          altText: `${pageContent.partnerInformation.partnerName} ${_t('Logo')}`,
        }}
        fadeOnScroll={true}
        gradientColors={[pageContent.partnerInformation.primaryColor, pageContent.partnerInformation.secondaryColor]}
        bannerImage={pageContent.partnerInformation.bannerImage.url}
        isDegreeHome
        userAgent={userAgent}
      />
    );
  } else {
    const firstPartner = partners[0] || { rectangularLogo: '', name: '' };
    let gradientColors: string[] = [];
    if (headerBackgroundColor.typeName === 'linearGradient2') {
      const lg2 = headerBackgroundColor.definition as LinearGradient2;
      gradientColors = [
        `rgb(${lg2.color1.red},${lg2.color1.green},${lg2.color1.blue})`,
        `rgb(${lg2.color2.red},${lg2.color2.green},${lg2.color2.blue})`,
      ];
    }
    return (
      <DegreeHeader
        headerImageUrl={headerImage as string}
        degreeName={name}
        // @ts-expect-error TS2769 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
        partner={firstPartner}
        gradientColors={gradientColors}
        userAgent={userAgent}
      />
    );
  }
};

export default DegreeHomeHeader;
